import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'

const Div = styled.div`
  padding:10px;
`;

// const Title = styled.div`
//   font-size: 16px;
//   font-weight: bold;
//   color: #262626;
//   line-height: 22px;
// `;

const Container = styled.div`
  display:flex;
  flex-wrap:wrap;
`;

const Card= styled.div`
  flex-shrink:0;
  margin:10px;
  padding:12px;
  width:160px;
  border: 1px solid #CCCCCC;
  border-radius:4px;
`;

const CardTitle = styled.div`
  text-align:center;
  font-size: 14px;
  color: #737373;
`;

const CardContent = styled.div`
  margin-top:8px;
  text-align:center;
  font-size: 20px;
  color: #404040;
  line-height:26px;
`;

const Gap = styled.div`
  height:20px;
  background-color:#f4f5f9;
`;



class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {  };
  }
  render() {
    const {t,data}=this.props
    return (
      <div>
        <Div>
          <Container>
            <Card><CardTitle>{t('Total Upload')}</CardTitle><CardContent>{data.totalUploadCount}</CardContent></Card>
            <Card><CardTitle>{t('Activating')}</CardTitle><CardContent>{data.activatingCount}</CardContent></Card>
            <Card><CardTitle>{t('Activate')}</CardTitle><CardContent>{data.activateCount}</CardContent></Card>
            <Card><CardTitle>{t('Normal')}</CardTitle><CardContent>{data.normalCount}</CardContent></Card>
            <Card><CardTitle>{t('Locking')}</CardTitle><CardContent>{data.lockingCount}</CardContent></Card>
            <Card><CardTitle>{t('Locked')}</CardTitle><CardContent>{data.lockedCount}</CardContent></Card>
            <Card><CardTitle>{t('Unlocking')}</CardTitle><CardContent>{data.unLockingCount}</CardContent></Card>
            {/* <Card><CardTitle>{t('Unlocked')}</CardTitle><CardContent>{data.unLockedCount}</CardContent></Card> */}
            <Card><CardTitle>{t('Completed')}</CardTitle><CardContent>{data.completedCount}</CardContent></Card>
          </Container>
        </Div>
        <Gap></Gap>
      </div>
    );
  }
}

export default withTranslation()(Dashboard);